import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

function AddMandal() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [name, setName] = useState("");
  const [area, setArea] = useState("");
  const [description, setDescription] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [isVisible] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location?.pathname || "";

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SuperAdmin") {
      navigate("/");
    }
  }, [navigate]);

  const handleSubmit = (e) => {
    setLoaded(true);
    e.preventDefault();

    // let data = new FormData();
    // data.append("Name", name);
    // data.append("Area", area);
    // data.append("isVisible", isVisible);

    let data = {
      Name: name,
      Area: area,
      Description: description || "",
      isVisible: isVisible,
    };

    let config = {
      method: "post",
      url: `${apiURL}/MandalDetails/Create`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: JSON.stringify(data),
    };

    axios
      .request(config)
      .then((response) => {
        setLoaded(false);
        setName("");
        setArea("");
        setDescription("");

        toast.success(response.data.message);
        // console.log(response);

        if (currentPath === "/add-mandal") {
          const timeOutId = setTimeout(() => {
            if (currentPath === "/add-mandal") {
              navigate("/manage-mandal");
            }
          }, 3000);
          return () => clearTimeout(timeOutId);
        }
      })
      .catch((error) => {
        setLoaded(false);
        toast.error(error.response?.data?.message);
      });
  };

  return (
    <Layout ac8="active">
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6">
              <h5>Add Mandal</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to={"/manage"}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={"/manage-mandal"}>Mandal List</Link>
                </li>
                <li className="breadcrumb-item">Add Mandal</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="mandalName">Name</label>{" "}
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="mandalName"
                        placeholder="Enter Mandal Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="mandalDescription">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        id="mandalDescription"
                        placeholder="Enter Mandal Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="mandalArea">Area</label>
                      <span className="text-danger">*</span>
                      <input
                        type="text"
                        className="form-control"
                        id="mandalArea"
                        placeholder="Enter Mandal Area"
                        value={area}
                        onChange={(e) => setArea(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="float-right">
                    <button
                      type="button"
                      className="btn btn-primary mx-2"
                      onClick={() => window.history.back()}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loaded}
                    >
                      {loaded ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </Layout>
  );
}

export default AddMandal;
